export default "__VITE_ASSET__BXiFkSR___"